import React from 'react';
import TextInput from '@techsoftware/happay-widgets/TextInput';
import DatePicker from '@techsoftware/happay-widgets/DatePicker';
import ScheduleDatePicker from '../../ReschedulePayment/rescheduleDatepicker';
import Grid from '@techsoftware/happay-widgets/Grid';
import { isMobile } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
export default function EditInvoiceDetail(props) {
  const {
    handleChange,
    invoiceDate,
    invoiceID,
    description,
    invoiceDueDate,
    drawCardUI,
    error: {
      invoiceDueDateError,
      invoiceDateError,
      invoiceIDError,
      descriptionError,
    },
    ocrScan,
    shimmer,
    ocrImg,
  } = props;
  const invoiceCardContent = (
    <Grid container className={`padding-lr-${isMobile ? '20' : '100'}`}>
      <Grid item>
        <Grid container justify="space-between" alignItems="flex-start">
          <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
            <DatePicker
              id="invoice-date"
              datePickerStyle={{ margin: '30px 0' }}
              required
              onChange={(e, val) => handleChange('invoiceDate', val)}
              floatingLabelText="Invoice Date"
              placeholder="Enter Date"
              value={invoiceDate}
              // todate={invoiceDueDate}
              disableNextDate
              format="DD MMM YYYY"
              errorText={invoiceDateError}
              errorType={invoiceDateError && 'error'}
              iconImg={ocrScan.invoiceDate && invoiceDate ? ocrImg : ''}
              iconType
              iconTooltip={
                ocrScan.invoiceDate && invoiceDate && 'Auto-fetched via ScanX'
              }
              iconTooltipPlacement="hw-bottom-left"
              shimmer={invoiceDate ? false : shimmer}
              disableToday
            />
          </Grid>
          <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
            <TextInput
              id="invoice-id"
              floatingLabelText="Invoice ID "
              hintText="Type Invoice ID"
              required
              value={invoiceID}
              type="text"
              onChange={(e, val) => handleChange('invoiceID', val)}
              errorText={invoiceIDError}
              errorType={invoiceIDError && 'error'}
              iconImg={ocrScan.invoiceID && invoiceID ? ocrImg : ''}
              iconType
              iconTooltip={
                ocrScan.invoiceID && invoiceID && 'Auto-fetched via ScanX'
              }
              shimmer={invoiceID ? false : shimmer}
            />
          </Grid>
        </Grid>
        <TextInput
          id="invoice-description"
          floatingLabelText="Invoice Description"
          hintText="Type Description"
          required
          customInputParentStyle={{ margin: 'unset' }}
          value={description}
          type="text"
          onChange={(e, val) => handleChange('description', val)}
          errorText={descriptionError}
          errorType={descriptionError && 'error'}
          iconImg={ocrScan.description && description ? ocrImg : ''}
          iconType
          iconTooltip={
            ocrScan.description && description && 'Auto-fetched via ScanX'
          }
        />
        <ScheduleDatePicker
          date={invoiceDueDate}
          onChange={(e, val) => handleChange('invoiceDueDate', val)}
          disabled={!invoiceDate}
          error={invoiceDueDateError}
          style={{ margin: '30px 0' }}
          id="invoice-due-date"
        />
      </Grid>
    </Grid>
  );
  return drawCardUI('Invoice Details', 2, invoiceCardContent);
}
